const halfLimit = 3;

export const useNavData = (pages, currentPageId) => {
  const pageIndex = pages.findIndex((page) => page.id === currentPageId);
  const total = pages.length;
  const start = Math.max(pageIndex - halfLimit, 0);
  const end = Math.min(halfLimit * 2 + start + 1, total);
  return {
    end,
    pages: pages.slice(start, end),
    pageIndex,
    start,
    total,
  };
};
